import { QueryHookOptions, useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { getPaginatedNodes } from './utils';
import {
  GetUnderwritingRulesQuery,
  GetUnderwritingRulesQueryVariables,
} from '../gql/graphql';

const GET_UNDERWRITING_RULES = graphql(`
  query getUnderwritingRules($submissionUuid: String!) {
    underwritingRules(
      pagination: { first: 100 }
      filters: { submissionUuid: $submissionUuid }
    ) {
      edges {
        cursor
        node {
          createdAt
          updatedAt
          status
          uuid
          reason
        }
      }
    }
  }
`);

export function useUnderwritingRulesQuery(
  submissionUuid?: string,
  options?: QueryHookOptions<
    GetUnderwritingRulesQuery,
    GetUnderwritingRulesQueryVariables
  >
) {
  const { loading, error, data, refetch } = useQuery(GET_UNDERWRITING_RULES, {
    skip: submissionUuid ? false : true,
    variables: {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      submissionUuid: submissionUuid!,
    },
    ...options,
  });

  const { underwritingRules } = useMemo(() => {
    return {
      underwritingRules: getPaginatedNodes(data?.underwritingRules),
    };
  }, [data]);

  return {
    loading,
    error,
    data,
    underwritingRules,
    refetch,
  };
}
